import { FC } from 'react'
import { Box } from '@mui/material'

import { GANTT_RESOURCE_COLUMN_ROW_HEIGHT } from '@gantt/constants'

type ResourceColumnCellProps = {
  values: string[]
}

export const ResourceColumnCell: FC<ResourceColumnCellProps> = props => {
  const { values } = props

  if (!values || values.length === 0) return null

  return (
    <Box
      style={{
        height: GANTT_RESOURCE_COLUMN_ROW_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
      }}
    >
      {values.map((value, index) => (
        <Box
          key={index}
          title={String(value)}
          sx={{
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Box>
      ))}
    </Box>
  )
}
